// @typescript-eslint/no-explicit-any

export enum EPageName {
    LANDING = "home",
    CATEGORY = "category",
    BANNER = "banner",
    ONESLIDE = "oneSlide",
    TWOSLIDE = "twoSlide",
    THREESLIDE = "threeSlide",
    FIVESLIDE = "fiveSlide",
    FOURSLIDE = "fourSlide",
    PACKAGESLIDE = "packageSlide",
    TRUSTEDVOICE="trustedVoice",
    CLIENTAWARD = "clientAward",
    LASERHAIRPACKAGE="laserHairPackage",
    AWARDS="awards",
    SLIDER="slider"
}

export interface CrouselDataProps{
    url:string;
    alt_name:string;
    object_cover?:boolean;
    /** Optional mobile-only asset for `<picture>` art direction (used by `ImageComponent`'s `mobile_url`). */
    mobile_url?:string | null;
}
export interface SingleCarouselCardProps {
    pageName: string;
    carousel_title?: string | null;
    crouselData?: any[];
    renderItem: (item: any, index: number) => React.ReactNode;
    showPagination?:boolean
    slideDelayTime?:number
    /** Pause carousel autoplay while user touches/drags on slide content (e.g. before/after slider on mobile) */
    pauseAutoplayOnSlideInteraction?: boolean
    /** Optional class for each slide (e.g. "h-full" for equal-height cards) */
    slideClassName?: string
    /** Called after Swiper instance is created (e.g. to hide SSR placeholder) */
    onSwiperReady?: () => void
    /** Swiper container height tracks active slide content (e.g. responsive hero images). */
    autoHeight?: boolean
    /** Disable for interactive slide content (Read More). Loop clones are not React-managed. */
    loop?: boolean
}
export interface SingleVideoCardProps {
    pageName: string;
    carousel_title?: string | null;
    crouselData?: any[];
    renderItem: (item: any, index: number,activeRealIndex:number) => React.ReactNode;
}

export interface ExperienceCardProps{
    image_url:string,
    description:string,
    title:string,
}

export interface SideTitleCrousalProps {
    pageName: string;
    carousel_title?: string | null;
    carousel_description?: string |null;
    crouselData?: any[];
    renderItem: (item: any, index: number,activeRealIndex:number) => React.ReactNode;
    showPagination?:boolean
    slideDelayTime?:number
}


export enum TemplateTypeEnum{
    TEMPLATE1='Template 1',
    TEMPLATE2='Template 2'
}


const MODAL_SIZES = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl",
    "3xl",
    "4xl",
    "5xl",
    "full",
  ] as const;
  
export type ModalSize = (typeof MODAL_SIZES)[number];
/** Desktop / tablet size for the booking modal. */
export const BOOK_APPOINTMENT_MODAL_SIZE : ModalSize = '5xl'
/** Mobile (<768px) size for the booking modal — full-screen so the tall iframe has room to breathe. */
export const BOOK_APPOINTMENT_MODAL_SIZE_MOBILE: ModalSize = 'full'

/** Desktop / tablet size for the free-trial modal. */
export const FREE_TRIAL_MODAL_SIZE : ModalSize = '5xl'
/** Mobile (<768px) size for the free-trial modal — full-screen so the tall iframe has room to breathe. */
export const FREE_TRIAL_MODAL_SIZE_MOBILE: ModalSize = 'full'

const MODAL_PLACEMENTS = [
    "center",
    "auto",
    "top",
    "top-center",
    "bottom",
    "bottom-center",
] as const;

/** HeroUI `Modal` placement; default when opening a modal is `"center"`. */
export type ModalPlacement = (typeof MODAL_PLACEMENTS)[number];

export const BOOK_APPOINTMENT_MODAL_PLACEMENT: ModalPlacement = 'top'

/** Career application form field character limits (match JobApplication model). */
export const CAREER_FORM_NAME_MAX = 200;
export const CAREER_FORM_EMAIL_MAX = 320;
export const CAREER_FORM_PHONE_MAX = 40;
export const CAREER_FORM_EXPERIENCE_MAX = 100;
export const CAREER_FORM_MESSAGE_MAX = 5000;
export const CAREER_FORM_ROLE_SLUG_MAX = 200;

// Calendar Iframe
export const COMPANY_CALENDAR_LINK = 'https://crm1.bytelogicindia.com/calendar'